import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { api__createPaymentSessionValidation } from "@/apis/checkout/createSession";
import usePaymentHook from "@/pages/checkout/CheckoutV2/hooks/usePaymentHook";
import stl from "@/pages/checkout/CheckoutV2/Checkout.module.css";
import { CDN_LINK } from "@globalConfig";
import HeadingSteps from "@/pages/checkout/shop-apply/shopApplyForm/HeadingSteps/HeadingSteps";
import Disclaimer from "@/_MiniApps/Disclaimer/Disclaimer";
import loadable from "@loadable/component";
import NDayGuarantee from "@/pages/checkout/components/NDayGuarantee/NDayGuarantee";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
import useFullLoading from "@hooks/useFullLoading";
import toast from "react-hot-toast";
import useIsMobile from "@hooks/useIsMobile";
import CreditCardInfoShimmer from "@/pages/checkout/CheckoutV2/components/CreditCardInfoShimmer";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import useBoolean from "@hooks/useBoolean";
import MobileCarInfoV2 from "@/pages/checkout/components/HeadingSteps/MobileCarInfo/MobileCarInfoV2";
var fallback = {
  fallback: null
};
var PaymentInfo = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "pages-checkout-components-PaymentInfo-PaymentInfo";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "pages-checkout-components-PaymentInfo-PaymentInfo" */"@/pages/checkout/components/PaymentInfo/PaymentInfo");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/pages/checkout/components/PaymentInfo/PaymentInfo");
    }
    return eval('require.resolve')("@/pages/checkout/components/PaymentInfo/PaymentInfo");
  }
}, fallback);
var Checkout = function Checkout(_ref) {
  var checkoutOrder = _ref.checkoutOrder,
    referralData = _ref.referralData,
    paymentSession = _ref.paymentSession,
    paymentProcessingUrl = _ref.paymentProcessingUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isMobile = useIsMobile();
  var isDesktop = !isMobile;
  var loading = useFullLoading();
  var grantedPopup = useBoolean();
  var on_initiating = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return api__createPaymentSessionValidation({
              order_id: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id,
              paymentProcessingUrl: paymentProcessingUrl
            });
          case 1:
            return _context.a(2, {});
          case 2:
            _context.p = 2;
            _t = _context.v;
            if (_t.trace) {
              toast.error(_t.trace);
            } else {
              toast.error(_t.message);
            }
            return _context.a(2, false);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function on_initiating() {
      return _ref2.apply(this, arguments);
    };
  }();
  var on_completed = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            return _context2.a(2, navigateTo("/payedsuccess?order_id=".concat(checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id, "&paymentStatus=paid")));
        }
      }, _callee2);
    }));
    return function on_completed() {
      return _ref3.apply(this, arguments);
    };
  }();
  usePaymentHook({
    divSelector: '.mysr-form',
    paymentSession: paymentSession.paymentSession,
    gatewayType: paymentSession.gateway_type,
    events: {
      on_initiating: on_initiating,
      on_completed: on_completed
    },
    template: {
      payButtonText: t("complete_pay_deposit", {
        ns: "web_checkout_cash"
      })
    },
    internvalTimeoutSeconds: 10
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, isDesktop && /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.backBtn].join(" ")
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return navigateTo("/checkout/shop-apply?post_id=".concat(checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_id));
    }
  }, t("cancel", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.moyasarFormWrapper
  }, /*#__PURE__*/React.createElement(HeadingSteps, {
    className: stl.steps
  }, /*#__PURE__*/React.createElement("span", {
    className: "completed"
  }, t("add_information", {
    ns: "web_checkout_cash"
  })), localStorage.getItem("otp_visited_".concat(checkoutOrder.id)) === "1" && /*#__PURE__*/React.createElement("span", {
    className: "completed"
  }, t("verify_code", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("span", {
    className: "active"
  }, t("payment", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("strong", {
    className: stl.payTitle
  }, t("choose_payment_method", {
    ns: "web_checkout_cash"
  })), isMobile && /*#__PURE__*/React.createElement(MobileCarInfoV2, {
    className: "mb-6",
    checkoutOrder: checkoutOrder,
    hideTitle: true,
    onClickInfoIcon: grantedPopup.setTrue
  }), /*#__PURE__*/React.createElement("div", {
    className: "mysr-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/React.createElement(CreditCardInfoShimmer, null))), isMobile && /*#__PURE__*/React.createElement(Disclaimer, {
    className: stl.Disclaimer
  })), isDesktop && /*#__PURE__*/React.createElement("div", {
    className: stl.stickyContainer
  }, /*#__PURE__*/React.createElement(PaymentInfo, {
    loading: loading,
    checkoutOrder: checkoutOrder,
    onClickInfoIcon: grantedPopup.setTrue,
    referralData: referralData
  }), checkoutOrder && checkoutOrder.post_is_new != 1 && /*#__PURE__*/React.createElement(NDayGuarantee, {
    img: CDN_LINK + "/assets/images/dm10.svg"
  })), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: grantedPopup.value,
    onClose: grantedPopup.setFalse,
    containerClassName: "!z-[999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-center text-[32px] font-bold leading-[32px]"
  }, t("shipping_cost_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#3C56D4] text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("shipping_cost_determined_sales_representative", {
    ns: "web_checkout_cash"
  }))))));
};
export default Checkout;